import { useState } from "react";
import { BlockStack, Button, Modal, Text } from "@shopify/polaris";
import { PrintIcon } from "@shopify/polaris-icons";
import { printSinglePartLabel } from "../../../shared/dymo/labels/parts_labels/partLabel";

const getLabelOptions = (line) => [
  {
    content: "Small label with qty",
    onAction: () => printSinglePartLabel({ ...line, id: line.produktnr }, true, true),
  },
  {
    content: "Small label per item",
    onAction: () => printSinglePartLabel({ ...line, id: line.produktnr }, false, true),
  },
  {
    content: "Big label with qty",
    onAction: () => printSinglePartLabel(line, true),
  },
  {
    content: "Big label per item",
    onAction: () => printSinglePartLabel(line, false),
  },
];

export const OrderLineLabelModal = ({ line }) => {
  const [open, setOpen] = useState(false);

  const handleAction = (action) => {
    action();
    setOpen(false);
  };

  return (
    <>
      <Button icon={PrintIcon} onClick={() => setOpen(true)}>
        Labels
      </Button>
      <Modal open={open} onClose={() => setOpen(false)} title={`Print labels for #${line.produktnr}`}>
        <Modal.Section>
          <BlockStack gap="300">
            <Text as="p" tone="subdued">
              Choose the label type for this order line.
            </Text>
            {getLabelOptions(line).map((option) => (
              <Button key={option.content} fullWidth size="large" textAlign="left" onClick={() => handleAction(option.onAction)}>
                {option.content}
              </Button>
            ))}
          </BlockStack>
        </Modal.Section>
      </Modal>
    </>
  );
};
